module.exports = __webpack_public_path__ + "static/media/coffee-pot.c31d329d.svg";